import { GET_ALL_MENU, GET_SALES_DATA, LOAD_MORE_SALES_DATA } from "../types";
import axios from "axios";
import { firebase } from "../../../firebase/initFirebase";
import moment from "moment";
import { store } from "../../store";
import { message } from "antd";
import S3 from "react-aws-s3";

export const getSalesData = (props) => {
  return async (dispatch) => {
    var reduxState = store.getState();
    var userRole = reduxState.auth.user.role;
    var useremail = reduxState.auth.user.email;
    var userLocation = reduxState.auth.user.branch;
    var userLocationName = reduxState.auth.user.branch_name;

    var Firestore = firebase.firestore();
    var dataRef = Firestore.collection("sales");
    console.log(props);

    dataRef = dataRef.orderBy("sale_date", "desc");
    // if(props.salesStatus){
    //   dataRef = dataRef.where("status", "==", "completed")
    // }
    if (!props.showVoided) {
      dataRef = dataRef.where("status", "==", "completed");
    }

    if (userRole !== "admin" && userRole !== "manager") {
      dataRef = dataRef.where("branch", "==", userLocation);
    }

    console.log(props);
    // if(props.searchText){
    //   dataRef = dataRef.orderBy('name').startAt(props.searchText).endAt(props.searchText + '\uf8ff')
    // }
    // if(props.filters){
    //   if(props.filters.length > 0){
    //     props.filters.map(item=>{
    //       console.log(item)
    //       dataRef = dataRef.orderBy(item.dataIndex).startAt(item.value).endAt(item.value + '\uf8ff')
    //     })
    //   }
    // }

    dataRef = dataRef.limit(40);

    var documentSnapshots = await dataRef.get();

    var docs = documentSnapshots.docs;
    var lastVisible = documentSnapshots.docs[documentSnapshots.docs.length - 1];
    var dataArray = [];

    await Promise.all(
      docs.map(async (salesItem) => {
        var newOrder = {
          key: salesItem.id,
          id: salesItem.id,
          ...salesItem.data(),
        };

        dataArray.push(newOrder);
      })
    );
    dispatch({
      type: GET_SALES_DATA,
      payload: {
        dataArray: dataArray,
        lastVisible: lastVisible,
        currentProps: props,
      },
    });
  };
};

export const loadMoreSalesData = () => {
  return async (dispatch) => {
    var reduxState = store.getState();
    var userRole = reduxState.auth.user.role;
    var useremail = reduxState.auth.user.email;
    var currentLastItem = reduxState.dailysales.lastVisible;
    var userLocation = reduxState.auth.user.branch;
    var userLocationName = reduxState.auth.user.branch_name;

    var currentProps = reduxState.dailysales.currentProps;
    var Firestore = firebase.firestore();

    var dataRef = Firestore.collection(currentProps.apiurl);

    dataRef = dataRef.orderBy("sale_date", "desc");

    // if(currentProps.salesStatus){
    //   dataRef = dataRef.where("status", "==", currentProps.salesStatus)
    // }
    dataRef = dataRef.where("status", "==", "completed");
    if (userRole !== "admin" && userRole !== "manager") {
      dataRef = dataRef.where("branch", "==", userLocation);
    }

    if (currentLastItem) {
      dataRef = dataRef.startAfter(currentLastItem);

      // if(currentProps.searchText){
      //   dataRef = dataRef.where('name', '>=', currentProps.searchText).where('name', '<=', currentProps.searchText+ '\uf8ff')
      // }

      dataRef = dataRef.limit(100);

      dataRef.get();
      var documentSnapshots = await dataRef.get();
      var docs = documentSnapshots.docs;
      if (docs) {
        var lastVisible =
          documentSnapshots.docs[documentSnapshots.docs.length - 1];
        var dataArray = [];
        await Promise.all(
          docs.map(async (salesItem) => {
            var newOrder = {
              key: salesItem.id,
              id: salesItem.id,
              ...salesItem.data(),
            };

            dataArray.push(newOrder);
          })
        );
        if (lastVisible && currentLastItem !== lastVisible) {
          dispatch({
            type: LOAD_MORE_SALES_DATA,
            payload: { dataArray: dataArray, lastVisible: lastVisible },
          });
        } else {
          message.error("No More Items To Load");
        }
      } else {
        message.error("No More Items To Load");
      }
    }
  };
};

export const getMenuItems = (props) => {
  return async (dispatch) => {
    var reduxState = store.getState();
    var userRole = reduxState.auth.user.role;
    var useremail = reduxState.auth.user.email;
    var userLocation = reduxState.auth.user.branch;
    var Firestore = firebase.firestore();

    var userLocationName = reduxState.auth.user.branch_name;

    var applyBrandFilter = false;
    if (userRole == "oic") {
      applyBrandFilter = true;
    }
    var productdataRef = Firestore.collection("products");
    // console.log(props)
    productdataRef = productdataRef.orderBy("category_name", "desc");

    var productdataRef1 = productdataRef.where("menu_item", "==", true);

    var documentSnapshots1 = await productdataRef1.get();

    var proddocs1 = documentSnapshots1.docs;

    var productdataRef2 = productdataRef.where("is_resell", "==", true);

    var documentSnapshots2 = await productdataRef2.get();

    var proddocs2 = documentSnapshots2.docs;

    var proddocs = [...proddocs1, ...proddocs2];

    console.log(proddocs);

    var newProds = [];
    await Promise.all(
      proddocs.map(async (item) => {
        var prodingredientsRef = Firestore.collection("products")
          .doc(item.id)
          .collection("ingredients");
        var ingredientsdocs = await prodingredientsRef.get();
        var newinds = [];
        if (ingredientsdocs.docs) {
          ingredientsdocs.docs.map((ind) => {
            if (ind.data()?.product) {
              newinds.push(ind.data());
            }
          });
        }
        var newProd = {
          key: item.id,
          id: item.id,
          ingredients: newinds,
          ...item.data(),
        };

        if (
          applyBrandFilter &&
          newProd?.brand_name &&
          newProd.brand_name.length > 0
        ) {
          if (
            userLocationName == "Pause" &&
            newProd.brand_name.includes("Pause")
          ) {
            newProds.push(newProd);
          } else if (
            userLocationName !== "Pause" &&
            newProd.brand_name.includes("19 Degrees")
          ) {
            newProds.push(newProd);
          }
        } else {
          newProds.push(newProd);
        }
      })
    );
    dispatch({ type: GET_ALL_MENU, payload: newProds });
  };
};

export const setSale = (
  products_sold,
  save_ingredients,
  createDate,
  sell_total
) => {
  return async (dispatch) => {
    var reduxState = store.getState();
    var Firestore = firebase.firestore();
    var userID = reduxState.auth.user.id;
    var userName = reduxState.auth.user.name;
    var userLocation = reduxState.auth.user.branch;
    var userLocationName = reduxState.auth.user.branch_name;

    var salesRef = Firestore.collection("sales").doc();

    console.log(save_ingredients);
    var salesData = {
      status: "completed",
      sale_date: createDate.format("YYYY-MM-DD HH:mm:ss"),
      created_at: moment().format("YYYY-MM-DD HH:mm:ss"),
      created_by: userID,
      created_name: userName,
      branch: userLocation,
      branch_name: userLocationName,
      products_sold: products_sold,
      used_ingredients: save_ingredients,
      total_sell_price: sell_total,
    };
    console.log(salesData);

    var salesndone = await salesRef.set(salesData, { merge: true });

    return "oks";
  };
};

export const voidSale = (record) => {
  return async (dispatch) => {
    var reduxState = store.getState();
    var Firestore = firebase.firestore();
    var userID = reduxState.auth.user.id;
    var userName = reduxState.auth.user.name;
    var userLocation = reduxState.auth.user.branch;
    var userLocationName = reduxState.auth.user.branch_name;

    var salesRef = Firestore.collection("sales").doc(record.id);

    var salesData = {
      status: "voided",
      voided_at: moment().format("YYYY-MM-DD HH:mm:ss"),
      voided_by: userID,
      voided_name: userName,
    };
    console.log(salesData);

    var salesndone = await salesRef.set(salesData, { merge: true });

    return "oks";
  };
};

export const setSaleDate = (record, newdate) => {
  return async (dispatch) => {
    var reduxState = store.getState();
    var Firestore = firebase.firestore();
    var userID = reduxState.auth.user.id;
    var userName = reduxState.auth.user.name;
    var userLocation = reduxState.auth.user.branch;
    var userLocationName = reduxState.auth.user.branch_name;

    var salesRef = Firestore.collection("sales").doc(record.id);

    var salesData = {
      sale_date: moment(newdate).format("YYYY-MM-DD HH:mm:ss"),
      sale_date_changed: userID,
      sale_date_changed_name: userName,
    };
    console.log(salesData);

    var salesndone = await salesRef.set(salesData, { merge: true });

    return "oks";
  };
};

export const fixSaleNoIngredients = (
  currentSalesOrder,
  products_sold,
  save_ingredients
) => {
  return async (dispatch) => {
    var reduxState = store.getState();
    var Firestore = firebase.firestore();
    var userID = reduxState.auth.user.id;
    var userName = reduxState.auth.user.name;
    var userLocation = reduxState.auth.user.branch;
    var userLocationName = reduxState.auth.user.branch_name;

    var salesRef = Firestore.collection("sales").doc(currentSalesOrder.id);

    console.log(save_ingredients);
    var salesData = {
      products_sold: products_sold,
      used_ingredients: save_ingredients,
    };
    console.log(salesData);

    var salesndone = await salesRef.set(salesData, { merge: true });

    return "oks";
  };
};

export const getProductSalesData = (props) => {
  return async (dispatch) => {
    try {
      var reduxState = store.getState();
      var userRole = reduxState.auth.user.role;
      var useremail = reduxState.auth.user.email;
      var userLocation = reduxState.auth.user.branch;
      var userLocationName = reduxState.auth.user.branch_name;

      var Firestore = firebase.firestore();
      var dataRef = Firestore.collection("sales");

      console.log("props", props);

      dataRef = dataRef.orderBy("sale_date", "desc");
      dataRef = dataRef.where("status", "==", "completed");

      if (userRole !== "admin" && userRole !== "manager") {
        dataRef = dataRef.where("branch", "==", userLocation);
      }

      // Filter by branch if provided in props
      if (props.branch) {
        dataRef = dataRef.where("branch", "==", props.branch);
      }

      // Filter by sale_date range if provided in props
      if (props.startDate && props.endDate) {
        dataRef = dataRef.where("sale_date", ">=", props.startDate);
        dataRef = dataRef.where("sale_date", "<=", props.endDate);
      }

      const batchSize = 100; // Adjust the batch size as needed
      const productToSearch = props.product; // Assuming 'props.product' contains the product ID to search for
      let lastDocument = null;
      let dataArray = [];

      while (true) {
        let query = dataRef.limit(batchSize);

        if (lastDocument) {
          query = query.startAfter(lastDocument);
        }

        const querySnapshot = await query.get();
        if (querySnapshot.empty) {
          break;
        }

        querySnapshot.forEach((doc) => {
          const data = doc.data();
          console.log(data);
          if (data.products_sold.some((item) => item.id == productToSearch)) {
            const sale_item = data.products_sold.filter(
              (item) => item.id == productToSearch
            );

            const prodSaleData = {
              branch: data.branch,
              branch_name: data.branch_name,
              created_at: data.created_at,
              sale_date: data.sale_date,
              ...sale_item[0],
            };
            console.log("prodSaleData", prodSaleData);
            dataArray.push(prodSaleData);
          }
        });

        lastDocument = querySnapshot.docs[querySnapshot.docs.length - 1];
        const lastDocumentData = lastDocument.data();
        message.loading(
          `Loading Data - last loaded (${lastDocumentData.sale_date})`
        );
      }

      console.log("Filtered Documents: ", dataArray);

      // Optionally dispatch the data to Redux store if needed
      dispatch({
        type: "SET_PRODUCT_SALES_DATA",
        payload: dataArray,
      });

      return dataArray;
    } catch (error) {
      console.error("Error getting documents: ", error);
      // Handle the error as needed
      throw error; // Propagate the error
    }
  };
};
